<template>
  <div class="tag-box">
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="name" label="名称" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="链接" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.url || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增、修改 -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          label="下载APP"
          prop="landPage"
          v-if="editType == 'landPage'"
        >
          <el-input v-model="form.landPage"></el-input>
        </el-form-item>
        <el-form-item
          label="telegram"
          prop="telegram"
          v-if="editType == 'telegram'"
        >
          <el-input v-model="form.telegram"></el-input>
        </el-form-item>
        <el-form-item label="potato" prop="potato" v-if="editType == 'potato'">
          <el-input v-model="form.potato"></el-input>
        </el-form-item>
        <el-form-item label="email" prop="email" v-if="editType == 'email'">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="twitter" prop="twitter" v-if="editType == 'twitter'">
          <el-input v-model="form.twitter"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [
        { name: "下载app", type: "landPage", url: "" },
        { name: "telegram", type: "telegram", url: "" },
        { name: "potato", type: "potato", url: "" },
        { name: "email", type: "email", url: "" },
        { name: "phone", type: "phone", url: "" },
        { name: "twitter", type: "twitter", url: "" },
      ],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        link: [{ required: true, message: "请输入链接地址", trigger: "blur" }],
      },
      form: {
        id: undefined,
        landPage: undefined,
        telegram: undefined,
        potato: undefined,
        phone: undefined,
        email: undefined,
        twitter: undefined,
      },
      dialogVisible: false,
      editType: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      API.queryConfig()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.form.id = res.data.id;
            this.tableData.forEach(item => {
              if (res.data[item.type]) {
                item.url = res.data[item.type]
              }
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.icon = res.data.coverImg;
    },
    // 新增标签配置
    addAndEdit(param) {
      console.log(param.type)
      this.editType = param.type;
      switch (this.editType) {
        case "landPage":
          this.form.landPage = param.url;
          break;
        case "telegram":
          this.form.landPage = param.url;
          break;
        case "potato":
          this.form.potato = param.url;
          break;
        case "twitter":
          this.form.twitter = param.url;
          break;
        case "phone":
          this.form.phone = param.url;
          break;
        case "email":
          this.form.email = param.url;
          break;
        default:
          break;
      }
      this.dialogVisible = true;
    },
    // 新增、修改提交
    onSubmit() {
      API.updateConfig(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addApp(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // if (
          //   this.form.link_url == "yinseinner://topic_page?id=" &&
          //   !this.topicId
          // ) {
          //   this.$message({
          //     type: "error",
          //     message: "请输入专题ID",
          //   });
          //   return;
          // }
          // if (this.form.link_url == "yinseinner://topic_page?id=") {
          //   this.form.link_url = this.form.link_url + this.topicId
          // }
          API.updateApp(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.dleApp(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              this.getList();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.landPage = undefined;
      this.form.telegram = undefined;
      this.form.twitter = undefined;
      this.form.email = undefined;
      this.form.phone = undefined;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
</style>
